import Echo from 'laravel-echo';
import PasswordValidator from 'password-validator';
import Pusher from 'pusher-js';
import { WEBSOCKET, WEBSOCKET_AUTH } from '@/constants';
import type { IToken } from '@/types';

window.Pusher = Pusher;

export const fileToBlob = async (file: File) => new Blob([new Uint8Array(await file.arrayBuffer())], { type: file.type });

export function isErrorWithMessage(error: unknown): error is { message: string } {
    return typeof error === 'object' && error != null && 'message' in error && typeof (error as { message: unknown }).message === 'string';
}

export function getMonth(month: number) {
    const months = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];

    return `months.${months[month]}`;
}
export function checkEmail(email: string) {
    const regExp = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9-]{1,20}.+.[A-Z]{2,4}$/i);
    if (regExp.test(email.trim())) {
        return true;
    }
    return false;
}

export function checkPassword(password: string) {
    const passwordSchema = new PasswordValidator();
    passwordSchema.is().min(8).is().max(100).has().uppercase().has().lowercase().has().digits().has().symbols().has().not().spaces();
    return passwordSchema.validate(password);
}
export function parseJwt(token: string) {
    try {
        const payload = token.split('.')[1];
        if (!payload) return null;
        return JSON.parse(atob(payload)) as IToken;
    } catch (_e) {
        return null;
    }
}

export const getSocket = (token: string) =>
    new Echo({
        broadcaster: 'pusher',
        key: 'PKAb4e2a6vhU4fD',
        cluster: 'mt1',
        authEndpoint: `${WEBSOCKET_AUTH}broadcasting/auth`,
        wsHost: WEBSOCKET,
        wsPort: 443,
        wssPort: 443,
        wsPath: '/ws',
        forceTLS: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        auth: {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    });
